import { addAction, addFilter, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    addFilter('media-carousel/owl-settings', () => ({
        margin: 10,
        items: 1,
        dots: false,
        nav: true,
        navText: [],
        responsive: { 0: { items: 2 }, 768: { items: 3 } },
    }));
});
